/**
 * Worth making this a module? Instead of using currency-symbol-map?
 * Also possible to add owner nouns? (Australian, Canadian)
 * */
export type CurrencyISO =
  | ''
  | 'AED'
  | 'AFN'
  | 'ALL'
  | 'AMD'
  | 'ANG'
  | 'AOA'
  | 'ARS'
  | 'AUD'
  | 'AWG'
  | 'AZN'
  | 'BAM'
  | 'BBD'
  | 'BDT'
  | 'BGN'
  | 'BHD'
  | 'BIF'
  | 'BMD'
  | 'BND'
  | 'BOB'
  | 'BOV'
  | 'BRL'
  | 'BSD'
  | 'BTN'
  | 'BWP'
  | 'BYR'
  | 'BYN'
  | 'BZD'
  | 'CAD'
  | 'CDF'
  | 'CHE'
  | 'CHF'
  | 'CHW'
  | 'CLF'
  | 'CLP'
  | 'CNY'
  | 'COP'
  | 'COU'
  | 'CRC'
  | 'CUC'
  | 'CUP'
  | 'CVE'
  | 'CZK'
  | 'DJF'
  | 'DKK'
  | 'DOP'
  | 'DZD'
  | 'EGP'
  | 'ERN'
  | 'ETB'
  | 'EUR'
  | 'FJD'
  | 'FKP'
  | 'GBP'
  | 'GEL'
  | 'GHS'
  | 'GIP'
  | 'GMD'
  | 'GNF'
  | 'GTQ'
  | 'GYD'
  | 'HKD'
  | 'HNL'
  | 'HRK'
  | 'HTG'
  | 'HUF'
  | 'IDR'
  | 'ILS'
  | 'INR'
  | 'IQD'
  | 'IRR'
  | 'ISK'
  | 'JMD'
  | 'JOD'
  | 'JPY'
  | 'KES'
  | 'KGS'
  | 'KHR'
  | 'KMF'
  | 'KPW'
  | 'KRW'
  | 'KWD'
  | 'KYD'
  | 'KZT'
  | 'LAK'
  | 'LBP'
  | 'LKR'
  | 'LRD'
  | 'LSL'
  | 'LTL'
  | 'LYD'
  | 'MAD'
  | 'MDL'
  | 'MGA'
  | 'MKD'
  | 'MMK'
  | 'MNT'
  | 'MOP'
  | 'MRO'
  | 'MRU'
  | 'MUR'
  | 'MVR'
  | 'MWK'
  | 'MXN'
  | 'MXV'
  | 'MYR'
  | 'MZN'
  | 'NAD'
  | 'NGN'
  | 'NIO'
  | 'NOK'
  | 'NPR'
  | 'NZD'
  | 'OMR'
  | 'PAB'
  | 'PEN'
  | 'PGK'
  | 'PHP'
  | 'PKR'
  | 'PLN'
  | 'PYG'
  | 'QAR'
  | 'RON'
  | 'RSD'
  | 'RUB'
  | 'RWF'
  | 'SAR'
  | 'SBD'
  | 'SCR'
  | 'SDG'
  | 'SEK'
  | 'SGD'
  | 'SHP'
  | 'SLL'
  | 'SOS'
  | 'SRD'
  | 'SSP'
  | 'STD'
  | 'STN'
  | 'SVC'
  | 'SYP'
  | 'SZL'
  | 'THB'
  | 'TJS'
  | 'TMT'
  | 'TND'
  | 'TOP'
  | 'TRY'
  | 'TTD'
  | 'TWD'
  | 'TZS'
  | 'UAH'
  | 'UGX'
  | 'USD'
  | 'USN'
  | 'UYI'
  | 'UYU'
  | 'UZS'
  | 'VEF'
  | 'VND'
  | 'VUV'
  | 'WST'
  | 'XAF'
  | 'XAG'
  | 'XAU'
  | 'XBA'
  | 'XBB'
  | 'XBC'
  | 'XBD'
  | 'XCD'
  | 'XDR'
  | 'XOF'
  | 'XPD'
  | 'XPF'
  | 'XPT'
  | 'XSU'
  | 'XTS'
  | 'XUA'
  | 'XXX'
  | 'YER'
  | 'ZAR'
  | 'ZMW'
  | 'ZMK'
  | 'ZWL';

export type ISO2 =
  | 'AF'
  | 'AX'
  | 'AL'
  | 'DZ'
  | 'AS'
  | 'AD'
  | 'AO'
  | 'AI'
  | 'AQ'
  | 'AG'
  | 'AR'
  | 'AM'
  | 'AW'
  | 'AU'
  | 'AT'
  | 'AZ'
  | 'BS'
  | 'BH'
  | 'BD'
  | 'BB'
  | 'BY'
  | 'BE'
  | 'BZ'
  | 'BJ'
  | 'BM'
  | 'BT'
  | 'BO'
  | 'BQ'
  | 'BA'
  | 'BW'
  | 'BV'
  | 'BR'
  | 'IO'
  | 'BN'
  | 'BG'
  | 'BF'
  | 'BI'
  | 'KH'
  | 'CM'
  | 'CA'
  | 'CV'
  | 'KY'
  | 'CF'
  | 'TD'
  | 'CL'
  | 'CN'
  | 'CX'
  | 'CC'
  | 'CO'
  | 'KM'
  | 'CG'
  | 'CD'
  | 'CK'
  | 'CR'
  | 'CI'
  | 'HR'
  | 'CU'
  | 'CW'
  | 'CY'
  | 'CZ'
  | 'DK'
  | 'DJ'
  | 'DM'
  | 'DO'
  | 'EC'
  | 'EG'
  | 'SV'
  | 'GQ'
  | 'ER'
  | 'EE'
  | 'ET'
  | 'FK'
  | 'FO'
  | 'FJ'
  | 'FI'
  | 'FR'
  | 'GF'
  | 'PF'
  | 'TF'
  | 'GA'
  | 'GM'
  | 'GE'
  | 'DE'
  | 'GH'
  | 'GI'
  | 'GR'
  | 'GL'
  | 'GD'
  | 'GP'
  | 'GU'
  | 'GT'
  | 'GG'
  | 'GN'
  | 'GW'
  | 'GY'
  | 'HT'
  | 'HM'
  | 'VA'
  | 'HN'
  | 'HK'
  | 'HU'
  | 'IS'
  | 'IN'
  | 'ID'
  | 'IR'
  | 'IQ'
  | 'IE'
  | 'IM'
  | 'IL'
  | 'IT'
  | 'JM'
  | 'JP'
  | 'JE'
  | 'JO'
  | 'KZ'
  | 'KE'
  | 'KI'
  | 'KP'
  | 'KR'
  | 'KW'
  | 'KG'
  | 'LA'
  | 'LV'
  | 'LB'
  | 'LS'
  | 'LR'
  | 'LY'
  | 'LI'
  | 'LT'
  | 'LU'
  | 'MO'
  | 'MK'
  | 'MG'
  | 'MW'
  | 'MY'
  | 'MV'
  | 'ML'
  | 'MT'
  | 'MH'
  | 'MQ'
  | 'MR'
  | 'MU'
  | 'YT'
  | 'MX'
  | 'FM'
  | 'MD'
  | 'MC'
  | 'MN'
  | 'ME'
  | 'MS'
  | 'MA'
  | 'MZ'
  | 'MM'
  | 'NA'
  | 'NR'
  | 'NP'
  | 'NL'
  | 'NC'
  | 'NZ'
  | 'NI'
  | 'NE'
  | 'NG'
  | 'NU'
  | 'NF'
  | 'MP'
  | 'NO'
  | 'OM'
  | 'PK'
  | 'PW'
  | 'PS'
  | 'PA'
  | 'PG'
  | 'PY'
  | 'PE'
  | 'PH'
  | 'PN'
  | 'PL'
  | 'PT'
  | 'PR'
  | 'QA'
  | 'RE'
  | 'RO'
  | 'RU'
  | 'RW'
  | 'BL'
  | 'SH'
  | 'KN'
  | 'LC'
  | 'MF'
  | 'PM'
  | 'VC'
  | 'WS'
  | 'SM'
  | 'ST'
  | 'SA'
  | 'SN'
  | 'RS'
  | 'SC'
  | 'SL'
  | 'SG'
  | 'SX'
  | 'SK'
  | 'SI'
  | 'SB'
  | 'SO'
  | 'ZA'
  | 'GS'
  | 'SS'
  | 'ES'
  | 'LK'
  | 'SD'
  | 'SR'
  | 'SJ'
  | 'SZ'
  | 'SE'
  | 'CH'
  | 'SY'
  | 'TW'
  | 'TJ'
  | 'TZ'
  | 'TH'
  | 'TL'
  | 'TG'
  | 'TK'
  | 'TO'
  | 'TT'
  | 'TN'
  | 'TR'
  | 'TM'
  | 'TC'
  | 'TV'
  | 'UG'
  | 'UA'
  | 'AE'
  | 'GB'
  | 'US'
  | 'UM'
  | 'UY'
  | 'UZ'
  | 'VU'
  | 'VE'
  | 'VN'
  | 'VG'
  | 'VI'
  | 'WF'
  | 'EH'
  | 'YE'
  | 'ZM'
  | 'ZW';

export enum CountryISO {
  AD = 'ad',
  AE = 'ae',
  AF = 'af',
  AG = 'ag',
  AI = 'ai',
  AL = 'al',
  AM = 'am',
  AO = 'ao',
  AQ = 'aq',
  AR = 'ar',
  AS = 'as',
  AT = 'at',
  AU = 'au',
  AW = 'aw',
  AX = 'ax',
  AZ = 'az',
  BA = 'ba',
  BB = 'bb',
  BD = 'bd',
  BE = 'be',
  BF = 'bf',
  BG = 'bg',
  BH = 'bh',
  BI = 'bi',
  BJ = 'bj',
  BL = 'bl',
  BM = 'bm',
  BN = 'bn',
  BO = 'bo',
  BQ = 'bq',
  BR = 'br',
  BS = 'bs',
  BT = 'bt',
  BV = 'bv',
  BW = 'bw',
  BY = 'by',
  BZ = 'bz',
  CA = 'ca',
  CC = 'cc',
  CD = 'cd',
  CF = 'cf',
  CG = 'cg',
  CH = 'ch',
  CI = 'ci',
  CK = 'ck',
  CL = 'cl',
  CM = 'cm',
  CN = 'cn',
  CO = 'co',
  CR = 'cr',
  CU = 'cu',
  CV = 'cv',
  CW = 'cw',
  CX = 'cx',
  CY = 'cy',
  CZ = 'cz',
  DE = 'de',
  DJ = 'dj',
  DK = 'dk',
  DM = 'dm',
  DO = 'do',
  DZ = 'dz',
  EC = 'ec',
  EE = 'ee',
  EG = 'eg',
  EH = 'eh',
  ER = 'er',
  ES = 'es',
  ET = 'et',
  FI = 'fi',
  FJ = 'fj',
  FK = 'fk',
  FM = 'fm',
  FO = 'fo',
  FR = 'fr',
  GA = 'ga',
  GB = 'gb',
  GD = 'gd',
  GE = 'ge',
  GF = 'gf',
  GG = 'gg',
  GH = 'gh',
  GI = 'gi',
  GL = 'gl',
  GM = 'gm',
  GN = 'gn',
  GP = 'gp',
  GQ = 'gq',
  GR = 'gr',
  GS = 'gs',
  GT = 'gt',
  GU = 'gu',
  GW = 'gw',
  GY = 'gy',
  HK = 'hk',
  HM = 'hm',
  HN = 'hn',
  HR = 'hr',
  HT = 'ht',
  HU = 'hu',
  ID = 'id',
  IE = 'ie',
  IL = 'il',
  IM = 'im',
  IN = 'in',
  IO = 'io',
  IQ = 'iq',
  IR = 'ir',
  IS = 'is',
  IT = 'it',
  JE = 'je',
  JM = 'jm',
  JO = 'jo',
  JP = 'jp',
  KE = 'ke',
  KG = 'kg',
  KH = 'kh',
  KI = 'ki',
  KM = 'km',
  KN = 'kn',
  KP = 'kp',
  KR = 'kr',
  KW = 'kw',
  KY = 'ky',
  KZ = 'kz',
  LA = 'la',
  LB = 'lb',
  LC = 'lc',
  LI = 'li',
  LK = 'lk',
  LR = 'lr',
  LS = 'ls',
  LT = 'lt',
  LU = 'lu',
  LV = 'lv',
  LY = 'ly',
  MA = 'ma',
  MC = 'mc',
  MD = 'md',
  ME = 'me',
  MF = 'mf',
  MG = 'mg',
  MH = 'mh',
  MK = 'mk',
  ML = 'ml',
  MM = 'mm',
  MN = 'mn',
  MO = 'mo',
  MP = 'mp',
  MQ = 'mq',
  MR = 'mr',
  MS = 'ms',
  MT = 'mt',
  MU = 'mu',
  MV = 'mv',
  MW = 'mw',
  MX = 'mx',
  MY = 'my',
  MZ = 'mz',
  NA = 'na',
  NC = 'nc',
  NE = 'ne',
  NF = 'nf',
  NG = 'ng',
  NI = 'ni',
  NL = 'nl',
  NO = 'no',
  NP = 'np',
  NR = 'nr',
  NU = 'nu',
  NZ = 'nz',
  OM = 'om',
  PA = 'pa',
  PE = 'pe',
  PF = 'pf',
  PG = 'pg',
  PH = 'ph',
  PK = 'pk',
  PL = 'pl',
  PM = 'pm',
  PN = 'pn',
  PR = 'pr',
  PS = 'ps',
  PT = 'pt',
  PW = 'pw',
  PY = 'py',
  QA = 'qa',
  RE = 're',
  RO = 'ro',
  RS = 'rs',
  RU = 'ru',
  RW = 'rw',
  SA = 'sa',
  SB = 'sb',
  SC = 'sc',
  SD = 'sd',
  SE = 'se',
  SG = 'sg',
  SH = 'sh',
  SI = 'si',
  SJ = 'sj',
  SK = 'sk',
  SL = 'sl',
  SM = 'sm',
  SN = 'sn',
  SO = 'so',
  SR = 'sr',
  SS = 'ss',
  ST = 'st',
  SV = 'sv',
  SX = 'sx',
  SY = 'sy',
  SZ = 'sz',
  TC = 'tc',
  TD = 'td',
  TF = 'tf',
  TG = 'tg',
  TH = 'th',
  TJ = 'tj',
  TK = 'tk',
  TL = 'tl',
  TM = 'tm',
  TN = 'tn',
  TO = 'to',
  TR = 'tr',
  TT = 'tt',
  TV = 'tv',
  TW = 'tw',
  TZ = 'tz',
  UA = 'ua',
  UG = 'ug',
  UM = 'um',
  US = 'us',
  UY = 'uy',
  UZ = 'uz',
  VA = 'va',
  VC = 'vc',
  VE = 've',
  VG = 'vg',
  VI = 'vi',
  VN = 'vn',
  VU = 'vu',
  WF = 'wf',
  WS = 'ws',
  XK = 'xk',
  YE = 'ye',
  YT = 'yt',
  ZA = 'za',
  ZM = 'zm',
  ZW = 'zw',
}

export interface Country {
  countryName: string;
  currency: CurrencyISO;
  symbol: string;
}
export const countries: Record<CountryISO, Country> = {
  ad: { countryName: 'Andorra', currency: 'EUR', symbol: '€' },
  ae: { countryName: 'United Arab Emirates', currency: 'AED', symbol: 'AED' },
  af: { countryName: 'Afghanistan', currency: 'AFN', symbol: 'Af' },
  ag: { countryName: 'Antigua and Barbuda', currency: 'XCD', symbol: 'XCD' },
  ai: { countryName: 'Anguilla', currency: 'XCD', symbol: 'XCD' },
  al: { countryName: 'Albania', currency: 'ALL', symbol: 'ALL' },
  am: { countryName: 'Armenia', currency: 'AMD', symbol: 'AMD' },
  ao: { countryName: 'Angola', currency: 'AOA', symbol: 'AOA' },
  aq: { countryName: 'Antarctica', currency: '', symbol: '' },
  ar: { countryName: 'Argentina', currency: 'ARS', symbol: 'AR$' },
  as: { countryName: 'American Samoa', currency: 'USD', symbol: '$' },
  at: { countryName: 'Austria', currency: 'EUR', symbol: '€' },
  au: { countryName: 'Australia', currency: 'AUD', symbol: 'AU$' },
  aw: { countryName: 'Aruba', currency: 'AWG', symbol: 'AWG' },
  ax: { countryName: 'Aland Islands', currency: 'EUR', symbol: '€' },
  az: { countryName: 'Azerbaijan', currency: 'AZN', symbol: 'man.' },
  ba: { countryName: 'Bosnia and Herzegovina', currency: 'BAM', symbol: 'KM' },
  bb: { countryName: 'Barbados', currency: 'BBD', symbol: 'BBD' },
  bd: { countryName: 'Bangladesh', currency: 'BDT', symbol: 'Tk' },
  be: { countryName: 'Belgium', currency: 'EUR', symbol: '€' },
  bf: { countryName: 'Burkina Faso', currency: 'XOF', symbol: 'CFA' },
  bg: { countryName: 'Bulgaria', currency: 'BGN', symbol: 'BGN' },
  bh: { countryName: 'Bahrain', currency: 'BHD', symbol: 'BD' },
  bi: { countryName: 'Burundi', currency: 'BIF', symbol: 'FBu' },
  bj: { countryName: 'Benin', currency: 'XOF', symbol: 'CFA' },
  bl: { countryName: 'Saint Barthelemy', currency: 'EUR', symbol: '€' },
  bm: { countryName: 'Bermuda', currency: 'BMD', symbol: 'BMD' },
  bn: { countryName: 'Brunei', currency: 'BND', symbol: 'BN$' },
  bo: { countryName: 'Bolivia', currency: 'BOB', symbol: 'Bs' },
  bq: {
    countryName: 'Bonaire, Saint Eustatius and Saba ',
    currency: 'USD',
    symbol: '$',
  },
  br: { countryName: 'Brazil', currency: 'BRL', symbol: 'R$' },
  bs: { countryName: 'Bahamas', currency: 'BSD', symbol: 'BSD' },
  bt: { countryName: 'Bhutan', currency: 'BTN', symbol: 'BTN' },
  bv: { countryName: 'Bouvet Island', currency: 'NOK', symbol: 'Nkr' },
  bw: { countryName: 'Botswana', currency: 'BWP', symbol: 'BWP' },
  by: { countryName: 'Belarus', currency: 'BYR', symbol: 'BYR' },
  bz: { countryName: 'Belize', currency: 'BZD', symbol: 'BZ$' },
  ca: { countryName: 'Canada', currency: 'CAD', symbol: 'CA$' },
  cc: { countryName: 'Cocos Islands', currency: 'AUD', symbol: 'AU$' },
  cd: {
    countryName: 'Democratic Republic of the Congo',
    currency: 'CDF',
    symbol: 'CDF',
  },
  cf: {
    countryName: 'Central African Republic',
    currency: 'XAF',
    symbol: 'FCFA',
  },
  cg: { countryName: 'Republic of the Congo', currency: 'XAF', symbol: 'FCFA' },
  ch: { countryName: 'Switzerland', currency: 'CHF', symbol: 'CHF' },
  ci: { countryName: 'Ivory Coast', currency: 'XOF', symbol: 'CFA' },
  ck: { countryName: 'Cook Islands', currency: 'NZD', symbol: 'NZ$' },
  cl: { countryName: 'Chile', currency: 'CLP', symbol: 'CL$' },
  cm: { countryName: 'Cameroon', currency: 'XAF', symbol: 'FCFA' },
  cn: { countryName: 'China', currency: 'CNY', symbol: 'CN¥' },
  co: { countryName: 'Colombia', currency: 'COP', symbol: 'CO$' },
  cr: { countryName: 'Costa Rica', currency: 'CRC', symbol: '₡' },
  cu: { countryName: 'Cuba', currency: 'CUP', symbol: 'CUP' },
  cv: { countryName: 'Cape Verde', currency: 'CVE', symbol: 'CV$' },
  cw: { countryName: 'Curacao', currency: 'ANG', symbol: 'ANG' },
  cx: { countryName: 'Christmas Island', currency: 'AUD', symbol: 'AU$' },
  cy: { countryName: 'Cyprus', currency: 'EUR', symbol: '€' },
  cz: { countryName: 'Czech Republic', currency: 'CZK', symbol: 'Kč' },
  de: { countryName: 'Germany', currency: 'EUR', symbol: '€' },
  dj: { countryName: 'Djibouti', currency: 'DJF', symbol: 'Fdj' },
  dk: { countryName: 'Denmark', currency: 'DKK', symbol: 'Dkr' },
  dm: { countryName: 'Dominica', currency: 'XCD', symbol: 'XCD' },
  do: { countryName: 'Dominican Republic', currency: 'DOP', symbol: 'RD$' },
  dz: { countryName: 'Algeria', currency: 'DZD', symbol: 'DA' },
  ec: { countryName: 'Ecuador', currency: 'USD', symbol: '$' },
  ee: { countryName: 'Estonia', currency: 'EUR', symbol: '€' },
  eg: { countryName: 'Egypt', currency: 'EGP', symbol: 'EGP' },
  eh: { countryName: 'Western Sahara', currency: 'MAD', symbol: 'MAD' },
  er: { countryName: 'Eritrea', currency: 'ERN', symbol: 'Nfk' },
  es: { countryName: 'Spain', currency: 'EUR', symbol: '€' },
  et: { countryName: 'Ethiopia', currency: 'ETB', symbol: 'Br' },
  fi: { countryName: 'Finland', currency: 'EUR', symbol: '€' },
  fj: { countryName: 'Fiji', currency: 'FJD', symbol: 'FJD' },
  fk: { countryName: 'Falkland Islands', currency: 'FKP', symbol: 'FKP' },
  fm: { countryName: 'Micronesia', currency: 'USD', symbol: '$' },
  fo: { countryName: 'Faroe Islands', currency: 'DKK', symbol: 'Dkr' },
  fr: { countryName: 'France', currency: 'EUR', symbol: '€' },
  ga: { countryName: 'Gabon', currency: 'XAF', symbol: 'FCFA' },
  gb: { countryName: 'United Kingdom', currency: 'GBP', symbol: '£' },
  gd: { countryName: 'Grenada', currency: 'XCD', symbol: 'XCD' },
  ge: { countryName: 'Georgia', currency: 'GEL', symbol: 'GEL' },
  gf: { countryName: 'French Guiana', currency: 'EUR', symbol: '€' },
  gg: { countryName: 'Guernsey', currency: 'GBP', symbol: '£' },
  gh: { countryName: 'Ghana', currency: 'GHS', symbol: 'GH₵' },
  gi: { countryName: 'Gibraltar', currency: 'GIP', symbol: 'GIP' },
  gl: { countryName: 'Greenland', currency: 'DKK', symbol: 'Dkr' },
  gm: { countryName: 'Gambia', currency: 'GMD', symbol: 'GMD' },
  gn: { countryName: 'Guinea', currency: 'GNF', symbol: 'FG' },
  gp: { countryName: 'Guadeloupe', currency: 'EUR', symbol: '€' },
  gq: { countryName: 'Equatorial Guinea', currency: 'XAF', symbol: 'FCFA' },
  gr: { countryName: 'Greece', currency: 'EUR', symbol: '€' },
  gs: {
    countryName: 'South Georgia and the South Sandwich Islands',
    currency: 'GBP',
    symbol: '£',
  },
  gt: { countryName: 'Guatemala', currency: 'GTQ', symbol: 'GTQ' },
  gu: { countryName: 'Guam', currency: 'USD', symbol: '$' },
  gw: { countryName: 'Guinea-Bissau', currency: 'XOF', symbol: 'CFA' },
  gy: { countryName: 'Guyana', currency: 'GYD', symbol: 'GYD' },
  hk: { countryName: 'Hong Kong', currency: 'HKD', symbol: 'HK$' },
  hm: {
    countryName: 'Heard Island and McDonald Islands',
    currency: 'AUD',
    symbol: 'AU$',
  },
  hn: { countryName: 'Honduras', currency: 'HNL', symbol: 'HNL' },
  hr: { countryName: 'Croatia', currency: 'HRK', symbol: 'kn' },
  ht: { countryName: 'Haiti', currency: 'HTG', symbol: 'HTG' },
  hu: { countryName: 'Hungary', currency: 'HUF', symbol: 'Ft' },
  id: { countryName: 'Indonesia', currency: 'IDR', symbol: 'Rp' },
  ie: { countryName: 'Ireland', currency: 'EUR', symbol: '€' },
  il: { countryName: 'Israel', currency: 'ILS', symbol: '₪' },
  im: { countryName: 'Isle of Man', currency: 'GBP', symbol: '£' },
  in: { countryName: 'India', currency: 'INR', symbol: 'Rs' },
  io: {
    countryName: 'British Indian Ocean Territory',
    currency: 'USD',
    symbol: '$',
  },
  iq: { countryName: 'Iraq', currency: 'IQD', symbol: 'IQD' },
  ir: { countryName: 'Iran', currency: 'IRR', symbol: 'IRR' },
  is: { countryName: 'Iceland', currency: 'ISK', symbol: 'Ikr' },
  it: { countryName: 'Italy', currency: 'EUR', symbol: '€' },
  je: { countryName: 'Jersey', currency: 'GBP', symbol: '£' },
  jm: { countryName: 'Jamaica', currency: 'JMD', symbol: 'J$' },
  jo: { countryName: 'Jordan', currency: 'JOD', symbol: 'JD' },
  jp: { countryName: 'Japan', currency: 'JPY', symbol: '¥' },
  ke: { countryName: 'Kenya', currency: 'KES', symbol: 'Ksh' },
  kg: { countryName: 'Kyrgyzstan', currency: 'KGS', symbol: 'KGS' },
  kh: { countryName: 'Cambodia', currency: 'KHR', symbol: 'KHR' },
  ki: { countryName: 'Kiribati', currency: 'AUD', symbol: 'AU$' },
  km: { countryName: 'Comoros', currency: 'KMF', symbol: 'CF' },
  kn: { countryName: 'Saint Kitts and Nevis', currency: 'XCD', symbol: 'XCD' },
  kp: { countryName: 'North Korea', currency: 'KPW', symbol: 'KPW' },
  kr: { countryName: 'South Korea', currency: 'KRW', symbol: '₩' },
  kw: { countryName: 'Kuwait', currency: 'KWD', symbol: 'KD' },
  ky: { countryName: 'Cayman Islands', currency: 'KYD', symbol: 'KYD' },
  kz: { countryName: 'Kazakhstan', currency: 'KZT', symbol: 'KZT' },
  la: { countryName: 'Laos', currency: 'LAK', symbol: 'LAK' },
  lb: { countryName: 'Lebanon', currency: 'LBP', symbol: 'LB£' },
  lc: { countryName: 'Saint Lucia', currency: 'XCD', symbol: 'XCD' },
  li: { countryName: 'Liechtenstein', currency: 'CHF', symbol: 'CHF' },
  lk: { countryName: 'Sri Lanka', currency: 'LKR', symbol: 'SLRs' },
  lr: { countryName: 'Liberia', currency: 'LRD', symbol: 'LRD' },
  ls: { countryName: 'Lesotho', currency: 'LSL', symbol: 'LSL' },
  lt: { countryName: 'Lithuania', currency: 'LTL', symbol: 'Lt' },
  lu: { countryName: 'Luxembourg', currency: 'EUR', symbol: '€' },
  lv: { countryName: 'Latvia', currency: 'EUR', symbol: '€' },
  ly: { countryName: 'Libya', currency: 'LYD', symbol: 'LD' },
  ma: { countryName: 'Morocco', currency: 'MAD', symbol: 'MAD' },
  mc: { countryName: 'Monaco', currency: 'EUR', symbol: '€' },
  md: { countryName: 'Moldova', currency: 'MDL', symbol: 'MDL' },
  me: { countryName: 'Montenegro', currency: 'EUR', symbol: '€' },
  mf: { countryName: 'Saint Martin', currency: 'EUR', symbol: '€' },
  mg: { countryName: 'Madagascar', currency: 'MGA', symbol: 'MGA' },
  mh: { countryName: 'Marshall Islands', currency: 'USD', symbol: '$' },
  mk: { countryName: 'Macedonia', currency: 'MKD', symbol: 'MKD' },
  ml: { countryName: 'Mali', currency: 'XOF', symbol: 'CFA' },
  mm: { countryName: 'Myanmar', currency: 'MMK', symbol: 'MMK' },
  mn: { countryName: 'Mongolia', currency: 'MNT', symbol: 'MNT' },
  mo: { countryName: 'Macao', currency: 'MOP', symbol: 'MOP$' },
  mp: { countryName: 'Northern Mariana Islands', currency: 'USD', symbol: '$' },
  mq: { countryName: 'Martinique', currency: 'EUR', symbol: '€' },
  mr: { countryName: 'Mauritania', currency: 'MRO', symbol: 'MRO' },
  ms: { countryName: 'Montserrat', currency: 'XCD', symbol: 'XCD' },
  mt: { countryName: 'Malta', currency: 'EUR', symbol: '€' },
  mu: { countryName: 'Mauritius', currency: 'MUR', symbol: 'MURs' },
  mv: { countryName: 'Maldives', currency: 'MVR', symbol: 'MVR' },
  mw: { countryName: 'Malawi', currency: 'MWK', symbol: 'MWK' },
  mx: { countryName: 'Mexico', currency: 'MXN', symbol: 'MX$' },
  my: { countryName: 'Malaysia', currency: 'MYR', symbol: 'RM' },
  mz: { countryName: 'Mozambique', currency: 'MZN', symbol: 'MTn' },
  na: { countryName: 'Namibia', currency: 'NAD', symbol: 'N$' },
  nc: { countryName: 'New Caledonia', currency: 'XPF', symbol: 'XPF' },
  ne: { countryName: 'Niger', currency: 'XOF', symbol: 'CFA' },
  nf: { countryName: 'Norfolk Island', currency: 'AUD', symbol: 'AU$' },
  ng: { countryName: 'Nigeria', currency: 'NGN', symbol: '₦' },
  ni: { countryName: 'Nicaragua', currency: 'NIO', symbol: 'C$' },
  nl: { countryName: 'Netherlands', currency: 'EUR', symbol: '€' },
  no: { countryName: 'Norway', currency: 'NOK', symbol: 'Nkr' },
  np: { countryName: 'Nepal', currency: 'NPR', symbol: 'NPRs' },
  nr: { countryName: 'Nauru', currency: 'AUD', symbol: 'AU$' },
  nu: { countryName: 'Niue', currency: 'NZD', symbol: 'NZ$' },
  nz: { countryName: 'New Zealand', currency: 'NZD', symbol: 'NZ$' },
  om: { countryName: 'Oman', currency: 'OMR', symbol: 'OMR' },
  pa: { countryName: 'Panama', currency: 'PAB', symbol: 'B/.' },
  pe: { countryName: 'Peru', currency: 'PEN', symbol: 'S/.' },
  pf: { countryName: 'French Polynesia', currency: 'XPF', symbol: 'XPF' },
  pg: { countryName: 'Papua New Guinea', currency: 'PGK', symbol: 'PGK' },
  ph: { countryName: 'Philippines', currency: 'PHP', symbol: '₱' },
  pk: { countryName: 'Pakistan', currency: 'PKR', symbol: 'PKRs' },
  pl: { countryName: 'Poland', currency: 'PLN', symbol: 'zł' },
  pm: {
    countryName: 'Saint Pierre and Miquelon',
    currency: 'EUR',
    symbol: '€',
  },
  pn: { countryName: 'Pitcairn', currency: 'NZD', symbol: 'NZ$' },
  pr: { countryName: 'Puerto Rico', currency: 'USD', symbol: '$' },
  ps: { countryName: 'Palestinian Territory', currency: 'ILS', symbol: '₪' },
  pt: { countryName: 'Portugal', currency: 'EUR', symbol: '€' },
  pw: { countryName: 'Palau', currency: 'USD', symbol: '$' },
  py: { countryName: 'Paraguay', currency: 'PYG', symbol: '₲' },
  qa: { countryName: 'Qatar', currency: 'QAR', symbol: 'QR' },
  re: { countryName: 'Reunion', currency: 'EUR', symbol: '€' },
  ro: { countryName: 'Romania', currency: 'RON', symbol: 'RON' },
  rs: { countryName: 'Serbia', currency: 'RSD', symbol: 'din.' },
  ru: { countryName: 'Russia', currency: 'RUB', symbol: 'RUB' },
  rw: { countryName: 'Rwanda', currency: 'RWF', symbol: 'RWF' },
  sa: { countryName: 'Saudi Arabia', currency: 'SAR', symbol: 'SR' },
  sb: { countryName: 'Solomon Islands', currency: 'SBD', symbol: 'SBD' },
  sc: { countryName: 'Seychelles', currency: 'SCR', symbol: 'SCR' },
  sd: { countryName: 'Sudan', currency: 'SDG', symbol: 'SDG' },
  se: { countryName: 'Sweden', currency: 'SEK', symbol: 'Skr' },
  sg: { countryName: 'Singapore', currency: 'SGD', symbol: 'S$' },
  sh: { countryName: 'Saint Helena', currency: 'SHP', symbol: 'SHP' },
  si: { countryName: 'Slovenia', currency: 'EUR', symbol: '€' },
  sj: { countryName: 'Svalbard and Jan Mayen', currency: 'NOK', symbol: 'Nkr' },
  sk: { countryName: 'Slovakia', currency: 'EUR', symbol: '€' },
  sl: { countryName: 'Sierra Leone', currency: 'SLL', symbol: 'SLL' },
  sm: { countryName: 'San Marino', currency: 'EUR', symbol: '€' },
  sn: { countryName: 'Senegal', currency: 'XOF', symbol: 'CFA' },
  so: { countryName: 'Somalia', currency: 'SOS', symbol: 'Ssh' },
  sr: { countryName: 'Suriname', currency: 'SRD', symbol: 'SRD' },
  ss: { countryName: 'South Sudan', currency: 'SSP', symbol: 'SSP' },
  st: { countryName: 'Sao Tome and Principe', currency: 'STD', symbol: 'STD' },
  sv: { countryName: 'El Salvador', currency: 'USD', symbol: '$' },
  sx: { countryName: 'Sint Maarten', currency: 'ANG', symbol: 'ANG' },
  sy: { countryName: 'Syria', currency: 'SYP', symbol: 'SY£' },
  sz: { countryName: 'Swaziland', currency: 'SZL', symbol: 'SZL' },
  tc: { countryName: 'Turks and Caicos Islands', currency: 'USD', symbol: '$' },
  td: { countryName: 'Chad', currency: 'XAF', symbol: 'FCFA' },
  tf: {
    countryName: 'French Southern Territories',
    currency: 'EUR',
    symbol: '€',
  },
  tg: { countryName: 'Togo', currency: 'XOF', symbol: 'CFA' },
  th: { countryName: 'Thailand', currency: 'THB', symbol: '฿' },
  tj: { countryName: 'Tajikistan', currency: 'TJS', symbol: 'TJS' },
  tk: { countryName: 'Tokelau', currency: 'NZD', symbol: 'NZ$' },
  tl: { countryName: 'East Timor', currency: 'USD', symbol: '$' },
  tm: { countryName: 'Turkmenistan', currency: 'TMT', symbol: 'TMT' },
  tn: { countryName: 'Tunisia', currency: 'TND', symbol: 'DT' },
  to: { countryName: 'Tonga', currency: 'TOP', symbol: 'T$' },
  tr: { countryName: 'Turkey', currency: 'TRY', symbol: 'TL' },
  tt: { countryName: 'Trinidad and Tobago', currency: 'TTD', symbol: 'TT$' },
  tv: { countryName: 'Tuvalu', currency: 'AUD', symbol: 'AU$' },
  tw: { countryName: 'Taiwan', currency: 'TWD', symbol: 'NT$' },
  tz: { countryName: 'Tanzania', currency: 'TZS', symbol: 'TSh' },
  ua: { countryName: 'Ukraine', currency: 'UAH', symbol: '₴' },
  ug: { countryName: 'Uganda', currency: 'UGX', symbol: 'USh' },
  um: {
    countryName: 'United States Minor Outlying Islands',
    currency: 'USD',
    symbol: '$',
  },
  us: { countryName: 'United States', currency: 'USD', symbol: '$' },
  uy: { countryName: 'Uruguay', currency: 'UYU', symbol: '$U' },
  uz: { countryName: 'Uzbekistan', currency: 'UZS', symbol: 'UZS' },
  va: { countryName: 'Vatican', currency: 'EUR', symbol: '€' },
  vc: {
    countryName: 'Saint Vincent and the Grenadines',
    currency: 'XCD',
    symbol: 'XCD',
  },
  ve: { countryName: 'Venezuela', currency: 'VEF', symbol: 'Bs.F.' },
  vg: { countryName: 'British Virgin Islands', currency: 'USD', symbol: '$' },
  vi: { countryName: 'U.S. Virgin Islands', currency: 'USD', symbol: '$' },
  vn: { countryName: 'Vietnam', currency: 'VND', symbol: '₫' },
  vu: { countryName: 'Vanuatu', currency: 'VUV', symbol: 'VUV' },
  wf: { countryName: 'Wallis and Futuna', currency: 'XPF', symbol: 'XPF' },
  ws: { countryName: 'Samoa', currency: 'WST', symbol: 'WST' },
  xk: { countryName: 'Kosovo', currency: 'EUR', symbol: '€' },
  ye: { countryName: 'Yemen', currency: 'YER', symbol: 'YR' },
  yt: { countryName: 'Mayotte', currency: 'EUR', symbol: '€' },
  za: { countryName: 'South Africa', currency: 'ZAR', symbol: 'R' },
  zm: { countryName: 'Zambia', currency: 'ZMK', symbol: 'ZK' },
  zw: { countryName: 'Zimbabwe', currency: 'ZWL', symbol: 'ZWL' },
};

export enum CurrencyToSymbol {
  aed = 'ae',
  ats = 'at',
  aud = 'au',
  bdt = 'bd',
  bef = 'be',
  bhd = 'bh',
  brl = 'br',
  bwp = 'bw',
  cad = 'ca',
  chf = 'ch',
  cny = 'cn',
  czk = 'cz',
  dem = 'de',
  dkk = 'dk',
  egp = 'eg',
  esp = 'es',
  eur = 'eu',
  fim = 'fi',
  frf = 'fr',
  gbp = 'gb',
  grd = 'gr',
  hkd = 'hk',
  huf = 'hu',
  idr = 'id',
  iep = 'ie',
  inr = 'in',
  itl = 'it',
  jpy = 'jp',
  krw = 'kr',
  luf = 'lu',
  mxn = 'mx',
  myr = 'my',
  nlg = 'nl',
  nok = 'no',
  nzd = 'nz',
  pln = 'pl',
  pte = 'pt',
  rub = 'ru',
  rur = 'ru',
  sar = 'sa',
  sek = 'se',
  sgd = 'sg',
  thb = 'th',
  trl = 'tr',
  twd = 'tw',
  usd = 'us',
  zar = 'za',
}
